export const glAccountingRegEX = new RegExp(/^\d{6}$/);
export const emailRegexPattern = new RegExp(
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/
);
// TODO: add all amex subsidiaries domains here
// export const amexEmailRegexPattern = new RegExp(/^[\w%+.-]+@((aexp|resy).com)$/);
export const amexEmailRegexPattern = new RegExp(
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/
);
export const phoneNoRegexPattern = new RegExp(/^\d*$/);
export const dashAplphanumericRegexPattern = new RegExp(/^[A-Za-z0-9-( )]*$/);
